import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialogapproveconfirm',
    templateUrl: './dialogapproveconfirm.component.html',
    styleUrls: ['./dialogapproveconfirm.component.css'],
    standalone: false
})
export class DialogapproveconfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
